import { EdgeView, Graph } from "@antv/x6"
import { LineEndToEdge, LineRecord } from "./modal"

interface ConnectPointOptions extends LineEndToEdge {
  lineId: CellId
}

function isLineEndConnectedToEdge(end: LineEndToEdge) {
  if (end?.cell && end?.anchor) {
    if ((end as any).port) {
      // some time there is dirty data.
      return false;
    }
    return true
  }
  return false
}

export function addVirtualPoints(lines: LineRecord[], graph: Graph) {
  const ends = lines.reduce((res: ConnectPointOptions[], current) => {
      const { source, target } = current as LineRecord
      if (isLineEndConnectedToEdge(source as LineEndToEdge)) {
        res.push({...source, lineId: current.id} as ConnectPointOptions)
      }
      if (isLineEndConnectedToEdge(target as LineEndToEdge)) {
        res.push({...target, lineId: current.id} as ConnectPointOptions)
      }
      return res
    }, [] as ConnectPointOptions[])

  ends.forEach((end: ConnectPointOptions) => {
    const cell = graph.getCellById(end.cell)
    const edgeView = <EdgeView>cell.findView(graph)!
    const targetLine = lines.find(item => item.id === end.cell)
    const points = targetLine!.vertices;
    const length = end.anchor.args.length
    const point = edgeView.getPointAtLength(length)!
    const connectPoint = {x: point.x, y: point.y, lineId: end.lineId}
    if (points.length === 0) {
      targetLine!.vertices = [connectPoint]
      return
    }
    const index = points.findIndex(item => {
      return edgeView.getClosestPointLength(item)! > length
    })
    if (index < 0) {
      targetLine!.vertices = [...points, connectPoint]
      return
    }
    points.splice(index, 0, connectPoint)
  })
}
